import { RelodeApiError } from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";

import { SearchCriteria, SearchResults } from "./jobSearchState";

enum names {
    SEARCH = "SEARCH",
    SEARCH_SUCCESS = "SEARCH_SUCCESS",
    SEARCH_FAILURE = "SEARCH_FAILURE",

    SEARCH_BY_TEXT = "SEARCH_BY_TEXT",

    NAVIGATE = "NAVIGATE",

    FILTER_SINGLE = "FILTER_SINGLE",
    FILTER_MULTIPLE = "FILTER_MULTIPLE",

    SEARCH_BY_SELECTED_FILTERS = "SEARCH_BY_SELECTED_FILTERS",

    SORT = "SORT",
    SORT_MOBILE = "SORT_MOBILE",

    CLEAR_ERRORS = "CLEAR_ERRORS",

    SELECT_ALL_JOBS = "SELECT_ALL_JOBS",
    DESELECT_ALL_JOBS = "DESELECT_ALL_JOBS",
    SET_JOB_CHECKED = "SET_JOB_CHECKED",
    SET_JOB_UNCHECKED = "SET_JOB_UNCHECKED",
}

export default names;

export const creators = {
    search: (criteria: SearchCriteria) =>
        createAction(names.SEARCH, { criteria }),
    searchSuccess: (results: SearchResults) =>
        createAction(names.SEARCH_SUCCESS, { results }),
    searchFailure: (error: RelodeApiError) =>
        createAction(names.SEARCH_FAILURE, { error }),
    searchText: (searchText: string) =>
        createAction(names.SEARCH_BY_TEXT, {
            searchText,
        }),
    navigate: (direction: "prev" | "next") =>
        createAction(names.NAVIGATE, { direction }),
    filterSingle: (
        id: string,
        name: string,
        item?: { label: string; value: string }
    ) => createAction(names.FILTER_SINGLE, { id, name, item }),
    filterMultiple: (
        id: string,
        name: string,
        category?: string,
        item?: { label: string; value: string }
    ) => createAction(names.FILTER_MULTIPLE, { id, name, category, item }),
    searchBySelectedFilters: (
        searchText?: string,
        distance?: number,
        locationId?: number,
        locationName?: string
    ) =>
        createAction(names.SEARCH_BY_SELECTED_FILTERS, {
            searchText,
            distance,
            locationId,
            locationName,
        }),
    sort: (field: string) => createAction(names.SORT, { field }),
    sortMobile: (field: string, direction: SortDir) =>
        createAction(names.SORT_MOBILE, { field, direction }),

    clearErrors: () => createAction(names.CLEAR_ERRORS),

    selectAllJobs: () => createAction(names.SELECT_ALL_JOBS),
    deselectAllJobs: () => createAction(names.DESELECT_ALL_JOBS),
    setJobChecked: (jobId: number) =>
        createAction(names.SET_JOB_CHECKED, { jobId }),
    setJobUnchecked: (jobId: number) =>
        createAction(names.SET_JOB_UNCHECKED, { jobId }),
};

export type JobSearchActionTypes = ActionsUnion<typeof creators>;
